import type { HTMLAttributes, ReactNode } from 'react';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  variant?: 'default' | 'interactive';
  children: ReactNode;
};

export function Card({ variant = 'default', className, children, ...props }: CardProps) {
  return (
    <div
      {...props}
      className={['hopper-card', `hopper-card--${variant}`, className].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  );
}
